"use client";

import React from "react";
import { motion } from "framer-motion";
import { LucideArrowRight } from "lucide-react";
import styles from "./CTA.module.css";
import clsx from "clsx";

export default function CTA() {
  return (
    <section className={clsx(styles.ctaWrapper, "w-full flex items-center justify-center px-6 md:px-16 bg-[#111111] text-[#F8F7F3]")}>
      <div className="max-w-4xl w-full text-center flex flex-col items-center gap-8">
        <span className="font-mono text-xs tracking-widest uppercase opacity-40">System Integration</span>
        
        <h2 className={clsx(styles.ctaTitle, "font-sans font-light tracking-tight leading-none text-white")}>
          Ready to deploy absolute <br />
          <span className="font-serif italic text-neutral-300">structural permanence?</span>
        </h2>
        
        <p className="max-w-md text-neutral-400 font-light text-sm md:text-base leading-relaxed">
          Request a physical sample matrix analysis grid or connect instantly with our custom mechanical execution architects.
        </p>

        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center gap-3 px-8 py-4 bg-[#F8F7F3] text-neutral-950 font-mono text-xs uppercase tracking-wider rounded-full mt-4 transition-colors duration-300 hover:bg-neutral-200"
        >
          <span>Initiate Technical Blueprint Consultation</span>
          <LucideArrowRight size={14} />
        </motion.button>
      </div>
    </section>
  );
}